import {Separator} from 'platform/components';
import {Box, HStack, Text} from 'platform/foundation';
import {useDateTimeFormatter} from 'platform/locale';

interface ThreadDateSeparatorProps {
  date: Date;
}

export function ThreadDateSeparator(props: ThreadDateSeparatorProps) {
  const formatDateTime = useDateTimeFormatter();

  return (
    <HStack align="center" spacing={3}>
      <Separator spacing={0} />
      <Box
        paddingHorizontal={3}
        paddingVertical={1}
        borderRadius="circular"
        backgroundColor="general.white"
        border="1px solid"
        borderColor="general.separator"
      >
        <Text size="xSmall" color="tertiary" noWrap>
          {formatDateTime('dateFull', props.date)}
        </Text>
      </Box>
      <Separator spacing={0} />
    </HStack>
  );
}
